import { Box, FormGroup, FormSection, Select, Text } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { OsasResendMijnKsyosQuestionnairesData } from '@common/validation/customControls/osas/osasResendMijnKsyosQuestionnairesSchema';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { EmailAddressFormGroup } from '../../EmailAddressFormGroup';
import { weeksOptions } from '../osasConsult/components/weeksOptions';

export function OsasResendMijnKsyosQuestionnairesEdit() {
    const { data, errors, onChange } = useProcessActivityEditContext<OsasResendMijnKsyosQuestionnairesData>();
    const { patient } = usePatientEpisodeCategoryContext();

    useEffect(() => {
        onChange(
            {
                patient: {
                    emailAddress: patient?.emailAddress ?? null,
                },
            },
            ['patient.emailAddress']
        );
    }, [patient]);

    return (
        <FormSection>
            <EmailAddressFormGroup
                data={data}
                errors={errors}
                onChange={onChange}
            />

            <FormGroup label={'Herzend Ksyos vragenlijsten'}>
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    gap={2}
                    mt={1}
                    size="sm"
                >
                    <Box width={'80px'}>
                        <Select
                            onChange={async (option) => {
                                onChange(
                                    {
                                        resendQuestionnairesWeeks: parseInt(option?.value ?? ''),
                                    },
                                    'resendQuestionnaires'
                                );
                            }}
                            options={weeksOptions}
                            value={{
                                label: data.resendQuestionnairesWeeks?.toString(),
                                value: data.resendQuestionnairesWeeks?.toString(),
                            }}
                        />
                    </Box>
                    <Text>weken</Text>
                </Box>
            </FormGroup>
        </FormSection>
    );
}
